import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-black" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_10 = { class: "sticky bottom-0 flex justify-end space-x-3 border-t border-gray-200 bg-white pt-4 dark:border-gray-700 dark:bg-black" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "-ml-1 mr-2 h-4 w-4 animate-spin text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { computed, ref, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useBrand } from '@/composables/brand/useBrand';
import { vehicleService } from '@/services/api/vehicleService';
import type { Vehicle } from '@/types/vehicle';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEditVehicleModal',
  props: {
    isOpen: { type: Boolean },
    vehicle: {}
  },
  emits: ["close", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toast = useToast();
const { brandColors } = useBrand();

const loading = ref(false);
const errors = ref<Record<string, string>>({});

const formData = ref({
  vehicle_make: '',
  vehicle_model: '',
  vehicle_year: 0,
  plate_number: '',
});

const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  for (let year = currentYear + 1; year >= 1980; year--) {
    years.push(year);
  }
  return years;
});

const inputStyle = computed(() => ({
  borderColor: brandColors.value.primary,
  '--tw-ring-color': brandColors.value.primary,
  outline: 'none',
}));

watch(
  () => props.vehicle,
  (newVehicle) => {
    if (!newVehicle) {
      return;
    }

    formData.value = {
      vehicle_make: newVehicle.vehicle_make || '',
      vehicle_model: newVehicle.vehicle_model || '',
      vehicle_year: newVehicle.vehicle_year || 0,
      plate_number: newVehicle.plate_number || '',
    };
    errors.value = {};
  },
  { immediate: true }
);

async function handleSubmit() {
  errors.value = {};

  if (!formData.value.vehicle_make.trim()) {
    errors.value.vehicle_make = 'Vehicle make is required';
  }

  if (!formData.value.vehicle_model.trim()) {
    errors.value.vehicle_model = 'Vehicle model is required';
  }

  if (!formData.value.vehicle_year) {
    errors.value.vehicle_year = 'Vehicle year is required';
  }

  if (!formData.value.plate_number.trim()) {
    errors.value.plate_number = 'Plate number is required';
  }

  if (Object.keys(errors.value).length > 0) {
    toast.error('Please fix the errors before submitting');
    return;
  }

  if (!props.vehicle) return;

  loading.value = true;
  try {
    const updated = await vehicleService.updateVehicle(
      props.vehicle.vehicle_id,
      { ...formData.value },
      [],
      []
    );
    toast.success('Vehicle updated successfully');
    emit('saved', updated);
    emit('close');
  } catch (err: any) {
    toast.error(err.response?.data?.message || 'Failed to update vehicle');
  } finally {
    loading.value = false;
  }
}

function handleClose() {
  if (!loading.value) {
    emit('close');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.vehicle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _withModifiers(handleClose, ["self"])
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", { class: "sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 dark:border-gray-700 dark:bg-black" }, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/20" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-amber-600 dark:text-amber-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          })
                        ])
                      ]),
                      _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, "Edit Vehicle")
                    ], -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleClose,
                      class: "text-gray-400 transition-colors duration-200 hover:text-gray-500 dark:hover:text-gray-300"
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Vehicle Information", -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("label", {
                            for: "vehicle_make",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Vehicle Make "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_make",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.vehicle_make) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_make]
                          ]),
                          (errors.value.vehicle_make)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.value.vehicle_make), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", {
                            for: "vehicle_model",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Vehicle Model "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_model",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.vehicle_model) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_model]
                          ]),
                          (errors.value.vehicle_model)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errors.value.vehicle_model), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", {
                            for: "vehicle_year",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Vehicle Year "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "vehicle_year",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.vehicle_year) = $event)),
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, [
                            _cache[8] || (_cache[8] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "Select year", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_7))
                            }), 128))
                          ], 4), [
                            [
                              _vModelSelect,
                              formData.value.vehicle_year,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (errors.value.vehicle_year)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.vehicle_year), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("label", {
                            for: "plate_number",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Plate Number "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "plate_number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.plate_number) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 font-mono uppercase text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.plate_number]
                          ]),
                          (errors.value.plate_number)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.value.plate_number), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: handleClose,
                        disabled: loading.value,
                        class: "rounded-lg bg-gray-200 px-4 py-2 font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-black dark:text-gray-300 dark:hover:bg-gray-600"
                      }, " Cancel ", 8, _hoisted_11),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: loading.value,
                        class: "flex items-center rounded-lg bg-amber-600 px-4 py-2 font-medium text-white transition-colors duration-200 hover:bg-amber-700 disabled:cursor-not-allowed disabled:opacity-50"
                      }, [
                        (loading.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[12] || (_cache[12] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(loading.value ? 'Updating...' : 'Update Vehicle'), 1)
                      ], 8, _hoisted_12)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})